<template>
    <div>
        <card-header title="Edit Application" icon="fa-pencil"/>

        <card-body>
            <application-form :card="card" :application="application"/>

        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteApp"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Application?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!application.title"
                    >
                        <i class="fas fa-check mr-2"></i>Save Application
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";


    import {client as http} from '../../http_client';
    import ApplicationForm from "./ApplicationForm.vue";

    export default {
        components: {ApplicationForm, SeparatorListItem, SubheaderListItem, CardListItem, NavigationListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                application: {outline: []},
                confirmDelete: false,
                dirty: null,
            };
        },
        methods: {
            loadApplication: function(force) {
                this.$emit('loading', true);
                http.get('applications/' + this.props.applicationId, {force}).then(response => { // TODO: temporary endpoint
                    if (!response.data.outline) response.data.outline = [];
                    this.application = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                this.$emit('loading', true);
                http.put('applications/' + this.props.applicationId, this.application, {force: true}).then(response => {
                    this.$reloadCard('applications');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            },
            deleteApp() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);
                    http.delete('applications/' + this.props.applicationId).then(response => {
                        this.$reloadCard('applications');
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            },
            reload() {
                this.loadApplication(true);
            }
        },
        watch: {
            'props.applicationId': function() {
                this.dirty = null;
                this.loadApplication();
            },
            'application': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this application? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadApplication();
        }
    };
</script>
